module.exports = __webpack_public_path__ + "img/gfm.b9048c41.png";